import React from 'react';
import TodayDeliveryBadge from '../../../../../../static/images/common/today_delivery_badge_icon.png';
import { setNumberWithComma } from '../../../../../../lib/common';
import { TimedealExposureWidgetItem } from '../../../../../../types/widget';
import { TimedealImageStyle, TimedealProductCardInfoStyle, TimedealProductCardWrapper } from './style';

interface TimedealProductCardProps {
  widgetItem: TimedealExposureWidgetItem;
}
const TimedealProductCard = (props: TimedealProductCardProps): JSX.Element => {
  const { widgetItem } = props;
  const { img, storeName, productName, originPrice, salesPrice, discountRate, coupon } = widgetItem;

  return (
    <TimedealProductCardWrapper>
      <TimedealImageStyle src={img?.[0]?.[0]?.url || ''} />
      <TimedealProductCardInfoStyle>
        <div className="product-info">
          <span className="store-name">{storeName}</span>
          <span className="product-name">{productName}</span>
          <div className="price-info">
            {discountRate && <span className="discount-rate">{`${discountRate}%`}</span>}
            <span className="sales-price">{setNumberWithComma(salesPrice)}원</span>
            <span className="origin-price">{setNumberWithComma(originPrice)}원</span>
            {!!coupon && <span className="coupon-text">(쿠폰 적용가)</span>}
          </div>
          <div className="today-delivery">
            <img src={TodayDeliveryBadge} alt="오늘출발 뱃지" />
          </div>
        </div>
      </TimedealProductCardInfoStyle>
    </TimedealProductCardWrapper>
  );
};

export default TimedealProductCard;
